.icon {
  flex: none;
  stroke-width: var(--icon-stroke);
}

.sm {
  width: var(--icon-sm);
  height: var(--icon-sm);
  stroke-width: 2;
}

.md {
  width: var(--icon-md);
  height: var(--icon-md);
}

.lg {
  width: var(--icon-lg);
  height: var(--icon-lg);
}
